import { Pipe, PipeTransform } from '@angular/core';
import { FORMULA_TYPE_DISPLAY_NAMES, FormulaType } from '@iot-platform/models/common';

@Pipe({
  name: 'formulaModelDisplay',
  standalone: true
})
export class FormulaModelDisplayPipe implements PipeTransform {
  transform(model: FormulaType | string | null | undefined): string | null | undefined {
    if (model === null || model === undefined) {
      return model;
    }
    return FORMULA_TYPE_DISPLAY_NAMES[model as FormulaType] ?? model;
  }
}
